import useDpcSessions from "./useDpcSessions";
import useCart from "./useCart";

export default function useDpcSession(){

    const sessions = useDpcSessions();

    const { cart } = useCart();

    if( !cart.session ) return null;

    return sessions.find(s => s.id.toString() === cart.session.toString()) || null;
}